/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreHttp from "@azure/core-http";

/** The result of a list request. */
export interface KeyListResult {
  /** The collection value. */
  items?: Key[];
  /** The URI that can be used to request the next set of paged results. */
  nextLink?: string;
}

export interface Key {
  /**
   * The name of the key.
   * NOTE: This property will not be serialized. It can only be populated by the server.
   */
  readonly name?: string;
}

/** Azure App Configuration error object. */
export interface ErrorModel {
  /** The type of the error. */
  type?: string;
  /** A brief summary of the error. */
  title?: string;
  /** The name of the parameter that resulted in the error. */
  name?: string;
  /** A detailed description of the error. */
  detail?: string;
  /** The HTTP status code that the error maps to. */
  status?: number;
}

/** The result of a list request. */
export interface KeyValueListResult {
  /** The collection value. */
  items?: ConfigurationSetting[];
  /** The URI that can be used to request the next set of paged results. */
  nextLink?: string;
}

export interface ConfigurationSetting {
  /** The unique name of the key-value. */
  key: string;
  /** The label of the key-value. */
  label?: string;
  /** The content type of the key-value. */
  contentType?: string;
  /** The value of the key-value. */
  value?: string;
  /** The time the key-value was last modified. */
  lastModified?: Date;
  /** Dictionary of <string> */
  tags?: { [propertyName: string]: string };
  /** Indicates whether or not this key-value is readonly. */
  isReadOnly?: boolean;
  /** The entity-tag of the key-value. */
  etag?: string;
}

/** The result of a list request. */
export interface LabelListResult {
  /** The collection value. */
  items?: Label[];
  /** The URI that can be used to request the next set of paged results. */
  nextLink?: string;
}

export interface Label {
  /**
   * The name of the label.
   * NOTE: This property will not be serialized. It can only be populated by the server.
   */
  readonly name?: string;
}

/** Defines headers for GeneratedClient_getKeys operation. */
export interface GeneratedClientGetKeysHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_checkKeys operation. */
export interface GeneratedClientCheckKeysHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getKeyValues operation. */
export interface GeneratedClientGetKeyValuesHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_checkKeyValues operation. */
export interface GeneratedClientCheckKeyValuesHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getKeyValue operation. */
export interface GeneratedClientGetKeyValueHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
  /** A UTC datetime that specifies the last time the resource was modified. */
  lastModified?: string;
}

/** Defines headers for GeneratedClient_putKeyValue operation. */
export interface GeneratedClientPutKeyValueHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
}

/** Defines headers for GeneratedClient_deleteKeyValue operation. */
export interface GeneratedClientDeleteKeyValueHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
}

/** Defines headers for GeneratedClient_checkKeyValue operation. */
export interface GeneratedClientCheckKeyValueHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
  /** A UTC datetime that specifies the last time the resource was modified. */
  lastModified?: string;
}

/** Defines headers for GeneratedClient_getLabels operation. */
export interface GeneratedClientGetLabelsHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_checkLabels operation. */
export interface GeneratedClientCheckLabelsHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_putLock operation. */
export interface GeneratedClientPutLockHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
}

/** Defines headers for GeneratedClient_deleteLock operation. */
export interface GeneratedClientDeleteLockHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
  /** An identifier representing the returned state of the resource. */
  eTag?: string;
}

/** Defines headers for GeneratedClient_getRevisions operation. */
export interface GeneratedClientGetRevisionsHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_checkRevisions operation. */
export interface GeneratedClientCheckRevisionsHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getKeysNext operation. */
export interface GeneratedClientGetKeysNextHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getKeyValuesNext operation. */
export interface GeneratedClientGetKeyValuesNextHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getLabelsNext operation. */
export interface GeneratedClientGetLabelsNextHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines headers for GeneratedClient_getRevisionsNext operation. */
export interface GeneratedClientGetRevisionsNextHeaders {
  /** Enables real-time consistency between requests by providing the returned value in the next request made to the server. */
  syncToken?: string;
}

/** Defines values for SettingFields. */
export type SettingFields =
  | "key"
  | "label"
  | "content_type"
  | "value"
  | "last_modified"
  | "tags"
  | "locked"
  | "etag";

/** Optional parameters. */
export interface GeneratedClientGetKeysOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned keys. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
}

/** Contains response data for the getKeys operation. */
export type GeneratedClientGetKeysResponse = GeneratedClientGetKeysHeaders &
  KeyListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetKeysHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientCheckKeysOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned keys. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
}

/** Contains response data for the checkKeys operation. */
export type GeneratedClientCheckKeysResponse = GeneratedClientCheckKeysHeaders & {
  /** The underlying HTTP response. */
  _response: coreHttp.HttpResponse & {
    /** The parsed HTTP response headers. */
    parsedHeaders: GeneratedClientCheckKeysHeaders;
  };
};

/** Optional parameters. */
export interface GeneratedClientGetKeyValuesOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the getKeyValues operation. */
export type GeneratedClientGetKeyValuesResponse = GeneratedClientGetKeyValuesHeaders &
  KeyValueListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyValueListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetKeyValuesHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientCheckKeyValuesOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the checkKeyValues operation. */
export type GeneratedClientCheckKeyValuesResponse = GeneratedClientCheckKeyValuesHeaders & {
  /** The underlying HTTP response. */
  _response: coreHttp.HttpResponse & {
    /** The parsed HTTP response headers. */
    parsedHeaders: GeneratedClientCheckKeyValuesHeaders;
  };
};

/** Optional parameters. */
export interface GeneratedClientGetKeyValueOptionalParams
  extends coreHttp.OperationOptions {
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** The label of the key-value to retrieve. */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
  /** Used to perform an operation only if the targeted resource's etag does not match the value provided. */
  ifNoneMatch?: string;
}

/** Contains response data for the getKeyValue operation. */
export type GeneratedClientGetKeyValueResponse = GeneratedClientGetKeyValueHeaders &
  ConfigurationSetting & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: ConfigurationSetting;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetKeyValueHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientPutKeyValueOptionalParams
  extends coreHttp.OperationOptions {
  /** The label of the key-value to create. */
  label?: string;
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
  /** Used to perform an operation only if the targeted resource's etag does not match the value provided. */
  ifNoneMatch?: string;
  /** The key-value to create. */
  entity?: ConfigurationSetting;
}

/** Contains response data for the putKeyValue operation. */
export type GeneratedClientPutKeyValueResponse = GeneratedClientPutKeyValueHeaders &
  ConfigurationSetting & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: ConfigurationSetting;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientPutKeyValueHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientDeleteKeyValueOptionalParams
  extends coreHttp.OperationOptions {
  /** The label of the key-value to delete. */
  label?: string;
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
}

/** Contains response data for the deleteKeyValue operation. */
export type GeneratedClientDeleteKeyValueResponse = GeneratedClientDeleteKeyValueHeaders &
  ConfigurationSetting & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: ConfigurationSetting;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientDeleteKeyValueHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientCheckKeyValueOptionalParams
  extends coreHttp.OperationOptions {
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** The label of the key-value to retrieve. */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
  /** Used to perform an operation only if the targeted resource's etag does not match the value provided. */
  ifNoneMatch?: string;
}

/** Contains response data for the checkKeyValue operation. */
export type GeneratedClientCheckKeyValueResponse = GeneratedClientCheckKeyValueHeaders & {
  /** The underlying HTTP response. */
  _response: coreHttp.HttpResponse & {
    /** The parsed HTTP response headers. */
    parsedHeaders: GeneratedClientCheckKeyValueHeaders;
  };
};

/** Optional parameters. */
export interface GeneratedClientGetLabelsOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned labels. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: string[];
}

/** Contains response data for the getLabels operation. */
export type GeneratedClientGetLabelsResponse = GeneratedClientGetLabelsHeaders &
  LabelListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: LabelListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetLabelsHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientCheckLabelsOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned labels. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: string[];
}

/** Contains response data for the checkLabels operation. */
export type GeneratedClientCheckLabelsResponse = GeneratedClientCheckLabelsHeaders & {
  /** The underlying HTTP response. */
  _response: coreHttp.HttpResponse & {
    /** The parsed HTTP response headers. */
    parsedHeaders: GeneratedClientCheckLabelsHeaders;
  };
};

/** Optional parameters. */
export interface GeneratedClientPutLockOptionalParams
  extends coreHttp.OperationOptions {
  /** The label, if any, of the key-value to lock. */
  label?: string;
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
  /** Used to perform an operation only if the targeted resource's etag does not match the value provided. */
  ifNoneMatch?: string;
}

/** Contains response data for the putLock operation. */
export type GeneratedClientPutLockResponse = GeneratedClientPutLockHeaders &
  ConfigurationSetting & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: ConfigurationSetting;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientPutLockHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientDeleteLockOptionalParams
  extends coreHttp.OperationOptions {
  /** The label, if any, of the key-value to unlock. */
  label?: string;
  /** Used to perform an operation only if the targeted resource's etag matches the value provided. */
  ifMatch?: string;
  /** Used to perform an operation only if the targeted resource's etag does not match the value provided. */
  ifNoneMatch?: string;
}

/** Contains response data for the deleteLock operation. */
export type GeneratedClientDeleteLockResponse = GeneratedClientDeleteLockHeaders &
  ConfigurationSetting & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: ConfigurationSetting;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientDeleteLockHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientGetRevisionsOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the getRevisions operation. */
export type GeneratedClientGetRevisionsResponse = GeneratedClientGetRevisionsHeaders &
  KeyValueListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyValueListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetRevisionsHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientCheckRevisionsOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the checkRevisions operation. */
export type GeneratedClientCheckRevisionsResponse = GeneratedClientCheckRevisionsHeaders & {
  /** The underlying HTTP response. */
  _response: coreHttp.HttpResponse & {
    /** The parsed HTTP response headers. */
    parsedHeaders: GeneratedClientCheckRevisionsHeaders;
  };
};

/** Optional parameters. */
export interface GeneratedClientGetKeysNextOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned keys. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
}

/** Contains response data for the getKeysNext operation. */
export type GeneratedClientGetKeysNextResponse = GeneratedClientGetKeysNextHeaders &
  KeyListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetKeysNextHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientGetKeyValuesNextOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the getKeyValuesNext operation. */
export type GeneratedClientGetKeyValuesNextResponse = GeneratedClientGetKeyValuesNextHeaders &
  KeyValueListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyValueListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetKeyValuesNextHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientGetLabelsNextOptionalParams
  extends coreHttp.OperationOptions {
  /** A filter for the name of the returned labels. */
  name?: string;
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: string[];
}

/** Contains response data for the getLabelsNext operation. */
export type GeneratedClientGetLabelsNextResponse = GeneratedClientGetLabelsNextHeaders &
  LabelListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: LabelListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetLabelsNextHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientGetRevisionsNextOptionalParams
  extends coreHttp.OperationOptions {
  /** Instructs the server to return elements that appear after the element referred to by the specified token. */
  after?: string;
  /** Requests the server to respond with the state of the resource at the specified time. */
  acceptDatetime?: string;
  /** A filter used to match keys. */
  key?: string;
  /** A filter used to match labels */
  label?: string;
  /** Used to select what fields are present in the returned resource(s). */
  select?: SettingFields[];
}

/** Contains response data for the getRevisionsNext operation. */
export type GeneratedClientGetRevisionsNextResponse = GeneratedClientGetRevisionsNextHeaders &
  KeyValueListResult & {
    /** The underlying HTTP response. */
    _response: coreHttp.HttpResponse & {
      /** The response body as text (string format) */
      bodyAsText: string;

      /** The response body as parsed JSON or XML */
      parsedBody: KeyValueListResult;
      /** The parsed HTTP response headers. */
      parsedHeaders: GeneratedClientGetRevisionsNextHeaders;
    };
  };

/** Optional parameters. */
export interface GeneratedClientOptionalParams
  extends coreHttp.ServiceClientOptions {
  /** Used to guarantee real-time consistency between requests. */
  syncToken?: string;
  /** Api Version */
  apiVersion?: string;
  /** Overrides client endpoint. */
  endpoint?: string;
}
